export const servicesContent = [
  {
    image: require("../../../../images/our-services/AIRBNB.png"),
    description:
      "Hassle-free Airbnb property management and services at your convenience",
    serviceName: "Airbnb Property Management Services",
    link: "/airbnb-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Residential Cleaning.png"),
    description:
      "Expert home cleaning for a fresh, welcoming space every time.",
    serviceName: "Residential Cleaning",
    link: "/residential-cleaning/",
  },
  {
    image: require("../../../../images/our-services/office cleaning.png"),
    description:
      "Comprehensive cleaning for offices and commercial spaces, ensuring a productive environment.",
    serviceName: "Office Cleaning / Commercial Cleaning",
    link: "/office-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Schools & Medical.png"),
    description:
      "Specialized cleaning for schools and medical facilities to maintain hygiene and safety.",
    serviceName: "Schools and Medical Cleaning",
    link: "/school-and-medical-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Bomd.png"),
    description:
      "End-of-lease cleaning that ensures your property is spotless for inspection.",
    serviceName: "Bond Cleaning",
    link: "/bond-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Window.png"), // Reusing the first image
    description: "Professional window cleaning for a crystal-clear view.",
    serviceName: "Window Cleaning",
    link: "/window-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Special Event Cleaning.png"), // Reusing the second image
    description:
      "Event cleaning services to leave the venue spotless after your special occasions.",
    serviceName: "Special Event Cleaning",
    link: "/special-event-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Carpet Steam Cleaning.png"), // Reusing the third image
    description: "Deep carpet steam cleaning for refreshed, dirt-free carpets.",
    serviceName: "Carpet Steam Cleaning",
    link: "/carpet-steam-cleaning/",
  },
  {
    image: require("../../../../images/our-services/Spring Cleaning.png"), // Reusing the fourth image
    description: "Thorough spring cleaning to revitalize your space.",
    serviceName: "Spring Cleaning",
    link: "/spring-cleaning/",
  },

  //Golder Services
  {
    image: require("../../../../images/our-services/AIRBNB.png"),
    description: "Gold Coast Airbnb property management and services.",
    serviceName: "Airbnb Property Management Gold Coast",
    link: "/airbnb-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Residential Cleaning.png"),
    description: "Professional apartment and unit cleaning on the Gold Coast.",
    serviceName: "Apartment Cleaning Gold Coast",
    link: "/apartment-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Bomd.png"),
    description: "Detailed Gold Coast bond cleaning for full bond return.",
    serviceName: "Bond Cleaning Gold Coast",
    link: "/bond-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Carpet Steam Cleaning.png"),
    description: "Deep steam carpet cleaning services across the Gold Coast.",
    serviceName: "Carpet Cleaning Gold Coast",
    link: "/carpet-cleaning-gold-coas/t",
  },
  {
    image: require("../../../../images/our-services/office cleaning.png"),
    description: "Reliable commercial and office cleaning on the Gold Coast.",
    serviceName: "Commercial Cleaning Gold Coast",
    link: "/commercial-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Spring Cleaning.png"),
    description: "Comprehensive Gold Coast deep cleaning services.",
    serviceName: "Deep Cleaning Gold Coast",
    link: "/deep-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Residential Cleaning.png"),
    description: "Professional Gold Coast housekeeping and domestic help.",
    serviceName: "Housekeeping Services Gold Coast",
    link: "/housekeeping-services/",
  },
  {
    image: require("../../../../images/our-services/Spring Cleaning.png"),
    description: "Sanitised move in cleaning for Gold Coast homes.",
    serviceName: "Move In Cleaning Gold Coast",
    link: "/move-in-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Bomd.png"),
    description: "Thorough Gold Coast move out and exit cleaning.",
    serviceName: "Move Out Cleaning Gold Coast",
    link: "/move-out-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Residential Cleaning.png"),
    description: "Trusted Gold Coast house and residential cleaning.",
    serviceName: "Residential Cleaning Gold Coast",
    link: "/residential-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/office cleaning.png"),
    description: "Hygienic Gold Coast restaurant and kitchen cleaning.",
    serviceName: "Restaurant Cleaning Gold Coast",
    link: "/restaurant-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Spring Cleaning.png"),
    description: "Seasonal Gold Coast spring cleaning for a fresh home.",
    serviceName: "Spring Cleaning Gold Coast",
    link: "/spring-cleaning-gold-coast/",
  },
  {
    image: require("../../../../images/our-services/Special Event Cleaning.png"),
    description: "Same-day urgent cleaning services on the Gold Coast.",
    serviceName: "Urgent Cleaning Gold Coast",
    link: "/urgent-cleaning-service/",
  },
];
